import { useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { getReviewItemApi } from "@/portals/patient/api/reviewItemsApi";
import { useFamily } from "@/portals/patient/context/FamilyContext";
import { useProfileFromQuery } from "@/portals/patient/hooks/useProfileFromQuery";
import { PageSpinner } from "@/shared/components/spinner";

/**
 * /patient/medications/review/:itemId — no longer a screen of its own; kept so
 * links in notifications sent before the change still land in the right
 * place. A finished review opens on the Medications tab; anything else (a
 * question, a conflict) opens in the Human Review Queue, where reviewing happens.
 */
export function ReviewItemPage() {
  const { itemId = "" } = useParams<{ itemId: string }>();
  // A notification link carries ?profile= — switch to that profile before looking the item up.
  const switchingProfile = useProfileFromQuery();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { activeDependent } = useFamily();
  const actingAsProfileId = activeDependent?.id;

  useEffect(() => {
    if (switchingProfile || searchParams.get("profile")) return;
    let cancelled = false;
    const id = encodeURIComponent(itemId);
    getReviewItemApi(itemId, actingAsProfileId).then(({ data }) => {
      if (cancelled) return;
      navigate(
        data?.itemStatus === "RESOLVED_CLINICIAN_VERIFIED" ? `/patient/medications?review=${id}` : `/patient/human-review-queue?item=${id}`,
        { replace: true },
      );
    });
    return () => {
      cancelled = true;
    };
  }, [itemId, actingAsProfileId, switchingProfile, searchParams, navigate]);

  return <PageSpinner className="bg-[#F7F7F7]" />;
}
